import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ArtifactSchema, FlatArtifact, TableGroupRow } from "@/types";
import { artifactColumns, artifactMatrixColumns } from "@/util";
import { appStore, artifactStore, selectionStore, timStore } from "@/hooks";
import {
  PanelCard,
  GroupableTable,
  AttributeChip,
  MultiselectInput,
} from "@/components/common";
import TraceMatrixChip from "./TraceMatrixChip.vue";


/**
 Displays a matrix of artifacts and their relationships.
 */
const __default__ = {
  name: "TraceTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const groupBy = ref<string | undefined>("type");
const rowTypes = ref<string[]>([]);
const colTypes = ref<string[]>([]);

const loading = computed(() => appStore.isLoading > 0);

const options = computed(() => timStore.typeNames);

const rows = computed(() => artifactStore.currentArtifacts);

const columnArtifacts = computed(() =>
  artifactStore.currentArtifacts.filter(
    ({ type }) => colTypes.value.length === 0 || colTypes.value.includes(type)
  )
);

const columns = computed(() => [
  ...artifactColumns,
  ...artifactMatrixColumns(columnArtifacts.value),
]);

const customCells = computed(() => [
  "type",
  ...columnArtifacts.value.map(({ id }) => id),
]);

/**
 * Filters out rows that don't match the selected row types.
 * @param row - The artifact to filter.
 * @return Whether to keep the row.
 */
function filterRow(row: FlatArtifact): boolean {
  return rowTypes.value.length === 0 || rowTypes.value.includes(row.type);
}

/**
 * Opens the view artifact side panel.
 * @param row - The artifact to view.
 */
function handleView(row: TableGroupRow | FlatArtifact) {
  if ("id" in row) {
    selectionStore.toggleSelectArtifact(String(row.id));
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(GroupableTable), {
        "group-by": groupBy.value,
        "onUpdate:groupBy": _cache[2] || (_cache[2] = ($event: any) => ((groupBy).value = $event)),
        columns: columns.value,
        rows: rows.value,
        "row-key": "id",
        "default-sort-by": "name",
        loading: loading.value,
        "filter-row": filterRow,
        "custom-cells": customCells.value,
        "data-cy": "view-trace-matrix-table",
        onRowClick: handleView
      }, _createSlots({
        "header-right": _withCtx(() => [
          _createVNode(_unref(MultiselectInput), {
            modelValue: rowTypes.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rowTypes).value = $event)),
            outlined: "",
            dense: "",
            clearable: "",
            "use-chips": false,
            options: options.value,
            label: "Row Types",
            b: "",
            class: "q-mr-sm q-mb-sm table-input",
            "data-cy": "input-trace-table-row-types"
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_unref(MultiselectInput), {
            modelValue: colTypes.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((colTypes).value = $event)),
            outlined: "",
            dense: "",
            clearable: "",
            "use-chips": false,
            options: options.value,
            label: "Column Types",
            b: "",
            class: "table-input q-mb-sm",
            "data-cy": "input-trace-table-col-types"
          }, null, 8, ["modelValue", "options"])
        ]),
        "body-cell-type": _withCtx(({ row }: { row: ArtifactSchema }) => [
          _createVNode(_unref(AttributeChip), {
            value: row.type,
            "artifact-type": ""
          }, null, 8, ["value"])
        ]),
        _: 2
      }, [
        _renderList(columnArtifacts.value, (artifact) => {
          return {
            name: `body-cell-${artifact.id}`,
            fn: _withCtx(({ row }) => [
              _createVNode(TraceMatrixChip, {
                source: row,
                target: artifact
              }, null, 8, ["source", "target"])
            ])
          }
        })
      ]), 1032, ["group-by", "columns", "rows", "loading", "custom-cells"])
    ]),
    _: 1
  }))
}
}

})